// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vw4tZ","buttons":"styles_buttons__2ghG3"};